import { createContext, Dispatch, SetStateAction, useContext } from 'react';

const defaultState = {
  sessionToken: '',
  setSessionToken() {},
};
interface AddressValidationContext {
  sessionToken: string;
  setSessionToken: Dispatch<SetStateAction<string>>;
}

export const AddressValidationSessionTokenContext =
  createContext<AddressValidationContext>(defaultState);

export const useAddressValidationSessionTokenContext = () =>
  useContext(AddressValidationSessionTokenContext);
